<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <!-- Main content -->
      <section class="content">
        <div class="box citic-box">
          <el-tabs
            v-model="activeName"
            @tab-click="handleClick"
          >
             <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-autocomplete
                      class="search"
                      v-model.trim="keywords1"
                      :fetch-suggestions="querySearch"
                      placeholder="按类别搜"
                      @select="handleSelect"
                      type="text"
                    ></el-autocomplete>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-autocomplete
                      class="search"
                      v-model.trim="keywords2"
                      :fetch-suggestions="querySearch2"
                      placeholder="按全称搜"
                      @select="handleSelect"
                      type="text"
                    ></el-autocomplete>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-autocomplete
                      class="search"
                      v-model.trim="keywords3"
                      :fetch-suggestions="querySearch3"
                      placeholder="按简称搜"
                      @select="handleSelect"
                      type="text"
                    ></el-autocomplete>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-button
                      @click="onSearch"
                      class="btn-search"
                      type="primary"
                    >搜索</el-button>
                    <el-button
                      @click="onDelete"
                      class="btn-search"
                      type="danger"
                    >删除</el-button>
                  </div>
                </el-col>
              </el-row>

            <el-tab-pane
              label="产品管理"
              name="0"
            >
              <el-button
                type="primary"
                @click="handleEdit()"
              >增加新产品</el-button>
              <el-table
                :data="productData"
                style="width:100%;margin-top: 20px; margin-bottom: 20px;"
                border
              >
                <el-table-column
                  prop="product_name"
                  label="产品名称"
                  width="200"
                  fixed
                ></el-table-column>
                <el-table-column
                  prop="category_name"
                  label="类别标签"
                  width="200"
                  fixed
                ></el-table-column>
                <el-table-column
                  label="厂商全称"
                  width="150"
                  prop="factoryqc_name"
                >
                </el-table-column>
                <el-table-column
                  prop="factory_name"
                  label="厂商简称"
                  width="180"
                ></el-table-column>
                <el-table-column
                  label="操作"
                  width="300"
                >
                  <template slot-scope="scope">
                    <el-button
                      @click="handleEdit(scope.row.id)"
                      type="primary"
                      size="small"
                    >编辑</el-button>
                    <el-button
                      @click="handleDelete(scope.row.id)"
                      type="danger"
                      size="small"
                    >删除</el-button>
                  </template>

                </el-table-column>
              </el-table>
              <!-- 分页 -->
              <div class="table-list__footer">
                <el-pagination
                  @current-change="handlePageChange"
                  :current-page="currentPage"
                  :page-size="page_size"
                  layout="total, prev, pager, next, jumper"
                  :total="total"
                >
                </el-pagination>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>

      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>

<script>
import axios from 'axios'
import ThePageHeader from '../../partials/ThePageHeader'
import TheSlideBox from '../../partials/TheSlideBox'
import TheSearchBox from '../../widgets/widgetSearchBox'
import Meeting from '../../widgets/widghtMeeting'
export default {
  name: 'PostHome',
  components: {
    ThePageHeader,
    TheSlideBox,
    TheSearchBox,
    Meeting
  },
  data () {
    return {
      activeName: '0',
      currentPage: '0',
      total: 0,
      pageSize: 10,
      loading: false,
      timeoutKeyWord: null,
      productData: [],
      keywords1: '',
      keywords2: '',
      keywords3: ''
    }
  },
  methods: {
    // 按类别搜索
    querySearch (keywords1, cb) {
      // if (!keywords1) return
      let url = this.$config.API.auto.category
      let data = {
        keywords: keywords1
      }
      axios.post(url, data).then(res => {
        if (res.status === 200) {
          cb(res.data.result)
        }
      })
    },
    // 全称
    querySearch2 (keywords2, cb) {
      // if (!keywords2) return
      let url = this.$config.API.auto.full
      let data = {
        keywords: keywords2
      }
      axios.post(url, data).then(res => {
        if (res.status === 200) {
          cb(res.data.result)
        }
      })
    },
    // 简称
    querySearch3 (keywords3, cb) {
      // if (!keywords3) return
      let url = this.$config.API.auto.alias
      let data = {
        keywords: keywords3
      }
      axios.post(url, data).then(res => {
        if (res.status === 200) {
          var keyAry = []
          for (var i in res.data.result) {
            // var obj = res.data.result[i].label
            keyAry.push({
              label: res.data.result[i].label,
              names: res.data.result[i].label,
              value: res.data.result[i].label,
              CID: res.data.result[i].value
            })
          }
          cb(keyAry)
          // console.log('222', keyAry)
          // var results = keywords3 ? keyAry.filter(this.createFilter(keywords3)) : restaurants
          // cb(results)
        }
      })
    },
    // 选择item
    handleSelect (item) {
      console.log(item)
    },
    // 搜索回车/虚拟操作键盘搜索
    onSearch () {
      this.timeoutKeyWord = setTimeout(() => {
        this.fetchData()
      }, 500)
    },
    // 删除搜索内容
    onDelete () {
      this.keywords1 = ''
      this.keywords2 = ''
      this.keywords3 = ''
      this.fetchData()
    },
    // 编辑修改内容
    handleEdit (id) {
      // this.currentEntityId = id
      // this.$refs.slideBox.scrollTo(0)
      this.$forceUpdate()
      if (id) {
        this.$router.push(`/product/edit/${id}`)
      } else {
        this.$router.push(`/product/new`)
      }
    },
    // 删除table内容
    handleDelete (id) {
      let url = this.$config.API.product.del
      let data = {
        product_id: id
      }
      axios.post(url, data).then(res => {
        this.$confirm('删除该产品信息?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.fetchData()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }).catch(err => {
        this.loading = false
        this.$message.error('该厂商有关联账号，删除失败')
        console.log(err)
      })
    },
    // tab切换
    handleClick (tab, event) {
      // console.log(tab, event)
    },
    // 获取列表数据
    fetchData () {
      let url = this.$config.API.product.list
      this.loading = true

      let data = {
        page: this.currentPage,
        categoryname: this.keywords1,
        factoryqcname: this.keywords2,
        factoryname: this.keywords3
      }
      axios.post(url, data).then(res => {
        this.productData = res.data.productList
        this.total = res.data.total
        this.loading = false
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 页面分页
    handlePageChange (page) {
      this.currentPage = page
      this.fetchData()
    }
  },
  mounted () {
    this.fetchData()
  }
}
</script>
<style lang="scss">
.citic-box {
  padding-top: 15px;
  .el-tabs__content {
    overflow: visible !important;
    position: static;
  }
  .box-header {
    ul.nav-tabs {
      margin-bottom: 0 !important;
      border-bottom: 0;
      li > a {
        color: #9ebbcd !important;
      }
      li.active > a {
        color: #333 !important;
      }
    }
  }
  .search {
    width: 80%;
    margin-bottom: 20px;
  }
  .btn-search {
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// product.vue?621602d0